import { Hexagen } from "../../types";

export enum BattleStages {
  INITIALISING = "INITIALISING",
  CHOOSE_MAIN_ATTACKING_CARD = "CHOOSE_MAIN_ATTACKING_CARD",
  AWAITING_HAND = "AWAITING_HAND",
  SELECT_SECONDARY_SIDE_CARD = "SELECT_SECONDARY_SIDE_CARD",
  SELECT_THIRD_SIDE_CARD = "SELECT_THIRD_SIDE_CARD",
  AWAITING_RESULT = "AWAITING_RESULT",
  WIN = "WIN",
  LOSE = "LOSE",
}

export type CardContainerProps = {
  hexagenUid: string | null | undefined;
  highlighted?: boolean;
  withZoom?: boolean;
  disableAppearAnimation?: boolean;
};

export type HandContainerProps = {
  hand: string[] | null | undefined;
  onSelect: (hexagenUid: string) => void;
};

export type ChooseCardPopupProps = {
  deck: Hexagen[];
  onSelect: (hexagen: Hexagen) => void;
};
